import * as React from 'react';
import { FC, ReactNode } from 'react';
import * as styles from './styles.css';
import { Typography } from '../Typography';
import cn from 'clsx';

export interface ILinkProps {
  beforeIcon?: ReactNode;
  afterIcon?: ReactNode;
  text: string;
  href: string;
  disabled?: boolean;
  color?: 'primary' | 'white';
  onClick?: () => void;
}

export const Link: FC<ILinkProps> = props => {
  const { beforeIcon, afterIcon, href, disabled = false, text, color = 'primary', onClick } = props;

  return (
    <a
      className={cn(styles['link'], styles[color], disabled && styles['disabled'])}
      rel="noopener"
      href={href}
      onClick={onClick}
    >
      {beforeIcon && <div className={styles['before-icon']}>{beforeIcon}</div>}

      <Typography.Text level={3} tag="span" color="currentColor" fontWeight="bold">
        {text}
      </Typography.Text>

      {afterIcon && <div className={styles['after-icon']}>{afterIcon}</div>}
    </a>
  );
};
